<script>
  import { format } from 'svelte-i18n';
  import { Badge } from '@sveltestrap/sveltestrap';

  import { PUSH_ACTION_COLORS } from '@client/enums';

  export let props = {};
  export let row = {};

  $: key = props.mode(row) || 'signature';
</script>

<div class="mode" style="border: 1px solid #{PUSH_ACTION_COLORS[key]}; color: #{PUSH_ACTION_COLORS[key]};">
  {$format('label.PUSH_HISTORY_MODE', { values: { mode: props.mode(row), action: props.action(row) } })}
</div>

<style lang="scss">
  .mode {
    border: 1px solid var(--color-gray-500);
    border-radius: var(--border-radius-base);
    color: var(--color-gray-600);
    display: inline-block;
    font-size: var(--font-size-xsmall);
    font-weight: var(--font-weight-medium);
    padding: var(--padding-small) var(--padding-base);
    text-transform: uppercase;
    white-space: nowrap;
  }
</style>
